var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 70,
        "footer-hide": true,
        title: "客户配送运费设置",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    {
                      staticClass: "small-form",
                      attrs: { "label-position": "top" },
                    },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "省份" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "", transfer: "" },
                                      on: { "on-change": _vm.onProvinceChange },
                                      model: {
                                        value: _vm.costForm.provinceUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "provinceUuid",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.provinceUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.provinceOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.regionUuid,
                                            attrs: { value: item.regionUuid },
                                          },
                                          [_vm._v(_vm._s(item.regionName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "城市" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "", transfer: "" },
                                      on: { "on-change": _vm.onCityChange },
                                      model: {
                                        value: _vm.costForm.cityUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "cityUuid",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.cityUuid",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "区域" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { transfer: "", filterable: "" },
                                      model: {
                                        value: _vm.costForm.distUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "distUuid",
                                            $$v
                                          )
                                        },
                                        expression: "costForm.distUuid",
                                      },
                                    },
                                    _vm._l(_vm.distOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "物流公司" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { transfer: "", filterable: "" },
                                      model: {
                                        value:
                                          _vm.costForm.logisticsCompanyUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.costForm,
                                            "logisticsCompanyUuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "costForm.logisticsCompanyUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.logisticsCompanyList,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.logisticsCompanyUuid,
                                            attrs: {
                                              value: item.logisticsCompanyUuid,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.logisticsCompanyName)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "运费" } },
                                [
                                  _c("decimal-input", {
                                    attrs: { precision: 4, min: 0 },
                                    model: {
                                      value:
                                        _vm.costForm
                                          .logisticsCompanyPerVolumePrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.costForm,
                                          "logisticsCompanyPerVolumePrice",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "costForm.logisticsCompanyPerVolumePrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "2" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: " " } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.onAddCost },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Table", {
                    attrs: {
                      columns: _vm.costTable.columns,
                      size: "small",
                      data: _vm.costTable.rows,
                      "highlight-row": "",
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            {
              staticClass: "row-margin-top-15",
              staticStyle: { "margin-top": "20px", "text-align": "right" },
              attrs: { gutter: 16 },
            },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }